import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable,of,throwError } from 'rxjs';
import { catchError, finalize, retry} from 'rxjs/operators';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { CommonService } from './common.service'
import { globals } from 'src/app/globals/globals';
import { AngularFireAuth } from '@angular/fire/auth';
import firebase from 'firebase/app';
import 'firebase/auth';
import { DeviceDetectorService } from 'ngx-device-detector';

declare var FB: any;


@Injectable({
  providedIn: 'root',
})
export class UserService {
  // $: any;
  private transactionInProgress = false
   deviceType: string = '';

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private title: Title,
    private meta: Meta,
    private afAuth: AngularFireAuth,
      private deviceService: DeviceDetectorService,
  ) {



     if (this.deviceService.isMobile()) {
      this.deviceType = 'mweb';
    } else if (this.deviceService.isTablet()) {
      this.deviceType = 'Tablet';
    } else {
      this.deviceType = 'browser';
    }
  }

  options = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  contact(contactInfo: any, region: string): Observable<any> {
    var params = {};
    //params["item"] = {};
    params['content'] = {};
    params['content']['title'] = 'feedback';
    params['content']['status'] = 'published';
    params['content']['email_id'] = contactInfo.controls.contact_email.value;
    params['content']['phone'] =
      '91' + contactInfo.controls.contact_mobile.value;
    params['content']['type_of_query'] =
      contactInfo.controls.contact_us_query.value;
    params['content']['subject'] = contactInfo.controls.query_description.value;
    return this.http
      .post<any>(
        environment.apiURL +
          'catalogs/616581dec61d1c05f7000000/items.gzip?region=' +
          region +
          '&auth_token=' +
          environment.authtoken,
        JSON.stringify(params),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }
  userDetails(sessionId: string, region: string): Observable<any> {
    if (!sessionId) {
      return throwError(() => new Error('Session ID is required to fetch user details.'));
    }
    return this.http
      .get<any>(
        environment.apiURL +
          'users/' +
          sessionId +
          '/account.gzip?region=' +
          region +
          '&auth_token=' +
          environment.authtoken +
          '&item_language=en'
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }


  


  login(region: any, mobile: string) {
    //http://52.77.225.92:3001/users/external_auth/sign_in
    var signin_params = {};
    signin_params['user'] = {};
    signin_params['user']['provider'] = '9mobile';
    signin_params['user']['uid'] = mobile;
    signin_params['user']['firstname'] = 'test';
    signin_params['user']['ext_account_email_id'] = 'test@gmail.com';
    signin_params['user']['region'] = region;
    signin_params['user']['mobile_number'] = '';
    signin_params['region'] = region;
    signin_params['auth_token'] = environment.authtoken;

    const data = {
      user: {
        email_id: 'shivakumar@saranyu.in',
        password: 'welcome123',
        region: 'any',
      },
    };
    return this.http
      .post<any>(
        environment.apiURL +
          'users/sign_in?auth_token=eKJTE4SSzAyKq3wdTCZ9&region=any',
        JSON.stringify(data),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  loginWithUserId(data) {
    return this.http
      .post<any>(
        environment.apiURL + 'v2/users/sign_in',
        JSON.stringify(data),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }



 

  getPopupDetails(region: string, userId: string) {
    //http://13.212.17.223:3001/users/get_popup_details?region=IN&auth_token=Nkz7pAqnqSPizUfNY8rx&ext_user_id=2348099445201
    return this.http
      .get<any>(
        environment.apiURL +
          'users/get_popup_details?region' +
          region +
          '&auth_token=' +
          environment.authtoken +
          '&ext_user_id=' +
          userId
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }
  emailLogin(userLogin: any) {
    var signin_params = {};
    signin_params['user'] = {};
    signin_params['user']['email_id'] = userLogin.controls.login_email.value;
    signin_params['user']['mobile_no'] = '';
    signin_params['user']['type'] = 'email';
    signin_params['user']['password'] =
      userLogin.controls.login_email_password.value;
    signin_params['user']['region'] = 'IN';

    return this.http
      .post<any>(
        environment.apiURL +
          'users/sign_in.gzip?region=IN&auth_token=' +
          environment.authtoken,
        JSON.stringify(signin_params),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  // emailRegister(userRegister: any) {
  //   var signup_params = {};
  //   signup_params["auth_token"] = "QuyZnN1jzCs3VToJQzYy";
  //   signup_params["user"] = {};
  //   signup_params["user"]["mobile_number"] = userRegister.controls.user_register_mobile.value;
  //   signup_params["user"]["device_type"] = "web"
  //   signup_params["user"]["firstname"] = userRegister.controls.user_register_name.value;
  //   signup_params["user"]["password"] = userRegister.controls.user_register_password.value;
  //   signup_params["user"]["confirm_password"] = userRegister.controls.user_register_confirm_password.value;
  //   signup_params["user"]["region"] = "NG";
  //   signup_params["user"]["user_email_id"] = userRegister.controls.user_register_email.value;

  //   return this.http.post<any>(environment.apiURL+"v2/signup", JSON.stringify(signup_params), this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  getLoginOtp(data) {
    // return this.http.post<any>(environment.apiURL+'v2/users/verify', JSON.stringify(data), this.options)
    // /users/send_otp?auth_token=eKJTE4SSzAyKq3wdTCZ9
    return this.http
      .post<any>(
        environment.apiURL +
          '/users/send_otp?auth_token=' +
          environment.authtoken,
        JSON.stringify(data),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }


    getEmail(data) {
      return this.http
        .post<any>(
          environment.apiURL +
            '/users/sign_in?auth_token=' +
            environment.authtoken,
          JSON.stringify(data),
          this.options
        )
        .pipe(retry(1), catchError(this.commonService.handleError));
    }


  loginwithOtp(otp, mob) {
    // &mobile_number=917549824282
    return (
      this.http
        .get<any>(
          environment.apiURL +
            `/users/verification/${otp}?auth_token=${environment.authtoken}&mobile_number=${mob}`,
          this.options
        )

        //  return this.http.get<any>(environment.apiURL+`/users/verification/${otp}?auth_token=${environment.authtoken}`, this.options)
        .pipe(retry(1), catchError(this.commonService.handleError))
    );
  }



   emailloginwithOtp(otp, email_id) {
    // &mobile_number=917549824282
    return (
      this.http
        .get<any>(
          environment.apiURL +
            `/users/verification/${otp}?auth_token=${environment.authtoken}&email_id=${email_id}&type=email`,
          this.options
        )

        //  return this.http.get<any>(environment.apiURL+`/users/verification/${otp}?auth_token=${environment.authtoken}`, this.options)
        .pipe(retry(1), catchError(this.commonService.handleError))
    );
  }

  // registerOtpVerify(data){
  //   return this.http.post<any>(environment.apiURL+'v2/users/verify', JSON.stringify(data), this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  resendOtp(data) {
    return this.http
      .post<any>(
        environment.apiURL +
          'v2/users/resend_otp?auth_token=' +
          environment.authtoken,
        JSON.stringify(data),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  resendRegisterVerification(fullMobile: string, region: string) {
    const resend_params = {
      user: {
        email_id: (fullMobile || '').replace(/^\+/, ''),
        type: 'msisdn',
      },
    };
    return this.http
      .post<any>(
        environment.apiURL +
          'users/resend_verification_link.gzip?region=' +
          (region || 'IN') +
          '&auth_token=' +
          environment.authtoken,
        JSON.stringify(resend_params),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  // forgotPassword(data){
  //   return this.http.post<any>(environment.apiURL+"v2/users/forgot_password",JSON.stringify(data),this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //   );
  // }

  // forgotPasswordOtpVerify(data){
  //   return this.http.post<any>(environment.apiURL+"v2/users/verify",JSON.stringify(data),this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //   );
  // }

  // resetPassword(data){
  //   return this.http.post<any>(environment.apiURL+"v2/users/reset_password",JSON.stringify(data),this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //   );
  // }

  // getForgotUserid(data){
  //   return this.http.post<any>(environment.apiURL+"v2/users/forgot_user_id",JSON.stringify(data),this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //   );
  // }

  getUpdateUserData(data, session_id) {
    // {{base_url}}/users/6f4923798c25e5944b5eb01a0adea923/account
    return this.http
      .put<any>(
        environment.apiURL + 'users/' + session_id + '/account',
        JSON.stringify(data),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  // getForgotUseridOtp(data){
  //   return this.http.post<any>(environment.apiURL+"v2/users/get_user_id",JSON.stringify(data),this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //   );
  // }

  // getSessionLimitApi(data){
  //   return this.http.post<any>(environment.apiURL+"v2/users/delete_first_session",JSON.stringify(data),this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //   );

  // }
  // mobileRegister1(userRegister: any) {
  //   var signup_params = {};
  //   signup_params["user"] = {};
  //   signup_params["user"]["firstname"] = userRegister.controls.mob_register_name.value;
  //   signup_params["user"]["password"] = userRegister.controls.mob_register_password.value;
  //   signup_params["user"]["region"] = "IN";
  //   signup_params["user"]["user_id"] = userRegister.controls.register_mobile_code.value.dial_code.substring(1) + userRegister.controls.user_register_mobile.value;
  //   signup_params["user"]["type"] = "msisdn";
  //   console.log(JSON.stringify(signup_params));
  //   return this.http.post<any>(environment.apiURL+"users.gzip?region=IN&auth_token="+environment.authtoken, JSON.stringify(signup_params), this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  // mobileRegister2(userRegister: any) {
  //   return this.http.get<any>(environment.apiURL+"users/verification/"+userRegister.controls.registerMobileOTP.value+".gzip?type=msisdn&mobile_number=" + userRegister.controls.register_mobile_code.value.dial_code.substring(1) + userRegister.controls.user_register_mobile.value+"&region=IN&auth_token="+environment.authtoken)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  // mobileRegisterResendOTP(userRegister: any, type: string) {
  //   var resend_params = {};
  //   resend_params["user"] = {};
  //   if(type == 'forgotpassotp') {
  //     resend_params["user"]["email_id"] = userRegister.controls.frgt_pwd_mobile_code.value.dial_code.substring(1) + userRegister.controls.frgt_pwd_mobile_no.value;
  //   }
  //   else if(type == 'registerotp'){
  //     resend_params["user"]["email_id"] = userRegister.controls.register_mobile_code.value.dial_code.substring(1) + userRegister.controls.user_register_mobile.value;
  //   }
  //   resend_params["user"]["type"] = "msisdn";
  //   console.log(JSON.stringify(resend_params));
  //   return this.http.post<any>(environment.apiURL+"users/resend_verification_link.gzip?region=IN&auth_token="+environment.authtoken, JSON.stringify(resend_params), this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  userSignout(sessionId: any): Observable<any> {
    return this.http
      .post<any>(
        environment.apiURL +
          'users/' +
          sessionId +
          '/sign_out?auth_token=' +
          environment.authtoken,
        {},
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  deleteUserAccount(userSessionId: any): Observable<any> {
    return this.http
      .get<any>(
        environment.apiURL + 'users/admin_delete?auth_token=' + environment.authtoken + '&user_id=' + userSessionId + '&type=user',
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  updateUser(updateUser: any, sessionId: string, region: string) {
    var user_params = {};
    user_params['user'] = {};
    user_params['user']['firstname'] =
      updateUser.controls.user_profile_name.value;
    user_params['user']['birthdate'] = updateUser.controls.datepicker.value;
    user_params['user']['user_email_id'] =
      updateUser.controls.user_email_address.value;
    user_params['user']['mobile_number'] =
      updateUser.controls.user_mobile_number.value;
    user_params['user']['address'] = updateUser.controls.user_address.value;
    user_params['user']['state'] = updateUser.controls.user_state.value;
    user_params['user']['country'] = updateUser.controls.user_country.value;
    // console.log(user_params);
    return this.http
      .put<any>(
        environment.apiURL +
          'users/' +
          sessionId +
          '/account.gzip?region=' +
          region +
          '&auth_token=' +
          environment.authtoken +
          '&item_language=en',
        JSON.stringify(user_params),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  // changePassword(changePassword: any, sessionId: string, region: string) {
  //   var password_params = {};
  //   password_params["user"] = {};
  //   password_params["user"]["current_password"] = changePassword.controls.old_change_password.value;
  //   password_params["user"]["password"] = changePassword.controls.new_change_password.value;
  //   password_params["user"]["confirm_password"] = changePassword.controls.new_change_confirm_password.value;
  //   password_params["user"]["region"] = region;

  //   return this.http.post<any>(environment.apiURL+"users/"+sessionId+"/change_password.gzip?region="+region+"&auth_token="+environment.authtoken, JSON.stringify(password_params), this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  // mobileForgotPassword1(userMobileForgot: any) {
  //   var forgot_password_params = {};
  //   forgot_password_params["user"] = {};
  //   forgot_password_params["user"]["region"] = "IN";
  //   forgot_password_params["user"]["user_id"] = userMobileForgot.controls.frgt_pwd_mobile_code.value.dial_code.substring(1) + userMobileForgot.controls.frgt_pwd_mobile_no.value;
  //   forgot_password_params["user"]["type"] = "msisdn";

  //   return this.http.post<any>(environment.apiURL+"users/forgot_password.gzip?region=IN&auth_token="+environment.authtoken, JSON.stringify(forgot_password_params), this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  // mobileForgotPassword2(userMobileForgot: any) {
  //   var forgot_password_params = {};
  //   forgot_password_params["user"] = {};
  //   forgot_password_params["user"]["key"] = userMobileForgot.controls.frgt_pwd_otp.value.toString();
  //   forgot_password_params["user"]["region"] = "IN";
  //   forgot_password_params["user"]["mobile_number"] = userMobileForgot.controls.frgt_pwd_mobile_code.value.dial_code.substring(1) + userMobileForgot.controls.frgt_pwd_mobile_no.value;

  //   return this.http.post<any>(environment.apiURL+"users/otp_verification.gzip?region=IN&auth_token="+environment.authtoken, JSON.stringify(forgot_password_params), this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  // mobileResetPassword(resetPassword: any, otpval: any, mobileno: any, type: any) {
  //   var reset_params = {};
  //   // console.log("resetPassword"+resetPassword.controls.reset_password.value);
  //   // console.log('otp value', otpval);
  //   reset_params["user"] = {};
  //   reset_params["user"]["key"] = otpval.toString();
  //   reset_params["user"]["password"] = resetPassword.controls.reset_password.value;
  //   reset_params["user"]["confirm_password"] = resetPassword.controls.reset_confirm_password.value;
  //   reset_params["user"]["user_id"] =  '91' + mobileno;
  //   reset_params["user"]["region"] = "IN";
  //   reset_params["user"]["type"] = 'msisdn';
  //   // console.log(reset_params);
  //   return this.http.post<any>(environment.apiURL+"v2/users/reset_password.gzip?region=IN&auth_token="+environment.authtoken, JSON.stringify(reset_params), this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  // emailForgotPassword(userMobileForgot: any) {
  //   var forgot_password_params = {};
  //   forgot_password_params["user"] = {};
  //   forgot_password_params["user"]["region"] = "IN";
  //   forgot_password_params["user"]["user_id"] = userMobileForgot.controls.frgt_pwd_email_id.value;
  //   forgot_password_params["user"]["type"] = "email";

  //   return this.http.post<any>(environment.apiURL+"users/forgot_password.gzip?region=IN&auth_token="+environment.authtoken, JSON.stringify(forgot_password_params), this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  // emaillResetPassword(resetPassword: any, forgot_key: any, region: string) {
  //   var reset_params = {};
  //   // console.log("resetPassword"+resetPassword);
  //   reset_params["user"] = {};
  //   reset_params["user"]["key"] = forgot_key;
  //   reset_params["user"]["password"] = resetPassword.reset_pwd;
  //   reset_params["user"]["confirm_password"] = resetPassword.reset_con_pwd;
  //   reset_params["user"]["region"] = "IN";

  //   return this.http.post<any>(environment.apiURL+"users/reset_password.gzip?region="+region+"&auth_token="+environment.authtoken, JSON.stringify(reset_params), this.options)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  watchlist(sessionId: string, region: string) {
    return this.http
      .get<any>(
        environment.apiURL +
          'users/' +
          sessionId +
          '/playlists/watchlater/listitems.gzip?region=' +
          region +
          '&auth_token=' +
          environment.authtoken
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  watchlistFilter(sessionId: string, region: string) {
    return this.http
      .get<any>(
        environment.apiURL +
          'v2/users/' +
          sessionId +
          '/playlists/watchlater/listitems.gzip?region=' +
          region +
          '&auth_token=' +
          environment.authtoken
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  favourites(sessionId: string, region: string) {
    return this.http
      .get<any>(
        environment.apiURL +
          'users/' +
          sessionId +
          '/playlists/favourite/listitems.gzip?region=' +
          region +
          '&auth_token=' +
          environment.authtoken
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }
  myPurchases(sessionId: string, region: string, userId: string) {
    return this.http
      .get<any>(
        environment.apiURL +
          'users/tvod_library_details?ext_user_id=' +
          userId +
          '&region=' +
          region +
          '&auth_token=' +
          environment.authtoken
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  autoRegion(region: string) {
    return this.http
      .get<any>(
        environment.apiURL +
          'regions/autodetect/ip.gzip?auth_token=' +
          environment.authtoken +
          '&region=' +
          region +
          '&item_language=en'
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  appConfig(region: string) {
    //https://ottapi.tarangplus.com//catalogs/message/items/app-config-params?current_version=116&auth_token=Fo6wSAEDpvYaxNXdSkKp&region=IN&item_language=en&asdf=2
    return this.http
      .get<any>(
        environment.apiURL +
          'catalogs/message/items/app-config-params.gzip?current_version=116&auth_token=' +
          environment.authtoken +
          '&region=' +
          region +
          '&item_language=en&asdf=2'
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  addWatchLater(sessionId: string, watchLaterParams: any, region: string) {
    // console.log(watchLaterParams)
    return this.http
      .post<any>(
        environment.apiURL +
          'users/' +
          sessionId +
          '/playlists/watchlater.gzip?region=' +
          region +
          '&auth_token=' +
          environment.authtoken,
        JSON.stringify(watchLaterParams),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  removeWatchlist(sessionId: string, itemId: any, region: string) {
    // console.log(itemId);
    return this.http
      .delete<any>(
        environment.apiURL +
          'users/' +
          sessionId +
          '/playlists/watchlater/listitems/' +
          itemId +
          '.gzip?region=' +
          region +
          '&auth_token=' +
          environment.authtoken
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  addToFavourites(sessionId: string, favouritesParam: any, region: string) {
    console.log('Add To Favourites');
    return this.http
      .post<any>(
        environment.apiURL +
          'users/' +
          sessionId +
          '/playlists/favourite.gzip?region=' +
          region +
          '&auth_token=' +
          environment.authtoken,
        JSON.stringify(favouritesParam),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  removeFavourite(sessionId: string, itemId: any, region: string) {
    // console.log(itemId);
    return this.http
      .delete<any>(
        environment.apiURL +
          'users/' +
          sessionId +
          '/playlists/favourite/listitems/' +
          itemId +
          '.gzip?region=' +
          region +
          '&auth_token=' +
          environment.authtoken
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  userVideoStatus(catalogId: string, contentId: any) {
    //http://localhost:3000/users/user_all_lists?catalog_id=5d79d1f6babd81589500024e&content_id=5de751fdbabd8149bc0004fd&item_category=
    return this.http
      .get<any>(
        environment.apiURL +
          'users/user_all_lists.gzip?catalog_id=' +
          catalogId +
          '&content_id=' +
          contentId +
          '&item_category='
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  // userVideoSubStatus(sessionId: string, catalogId: string, contentId: any, region: string) {
  //   //http://13.233.16.182/users/05b0db73039c1e35361c3926da3804e9/get_all_details?catalog_id=5d301a74babd8131f6000019&content_id=5defab87babd816cef000090&category=&region=IN&auth_token=3zZmzoHg8z6SM3wpDoyw
  //   return this.http.get<any>(environment.apiURL+"users/"+sessionId+"/get_all_details.gzip?catalog_id="+catalogId+"&content_id="+contentId+"&category="+"?region="+region+"&auth_token="+environment.authtoken)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  getContinueWatching(sessionId: string, region: string): Observable<any> {
    return this.http
      .get<any>(
        environment.apiURL +
          'users/' +
          sessionId +
          '/playlists/watchhistory/listitems.gzip?region=' +
          region +
          '&auth_token=' +
          environment.authtoken
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }
  removeContinueWatching(
    sessionId: string,
    playListId: string,
    region: string
  ): Observable<any> {
    return this.http
      .delete<any>(
        environment.apiURL +
          'users/' +
          sessionId +
          '/playlists/watchhistory/listitems/' +
          playListId +
          '.gzip?region=' +
          region +
          '&auth_token=' +
          environment.authtoken
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  deleteWatchHistory(sessionId: string, region: string): Observable<any> {
    return this.http
      .delete<any>(
        environment.apiURL +
          'users/' +
          sessionId +
          '/playlists/watchhistory/clear_all.gzip?region=' +
          region +
          '&auth_token=' +
          environment.authtoken
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  // emailConfirmation(token: string){
  //   // http://52.1.200.151/users/confirmation?confirmation_token=b788ce81cf98f0b576a36962ddcd833b&auth_token=KypSUhgYPP6UVkp32gCf
  //   return this.http.get<any>(environment.apiURL+"users/confirmation.gzip?confirmation_token="+token+"&auth_token="+environment.authtoken)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  getGenerateToken(session: string, token: string, region: string) {
    var params = {};
    params['auth_token'] = environment.authtoken;
    params['user'] = {};
    params['user']['token'] = token;
    params['user']['session_id'] = session;
    params['region'] = region;
    return this.http
      .post<any>(
        environment.apiURL + 'generate_session_tv.gzip',
        JSON.stringify(params),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  getAllDetails(obj: any) {
    return this.http
      .post<any>(
        environment.apiURL + 'v2/users/get_all_details.gzip',
        JSON.stringify(obj),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  getUserDetailsLogin() {
    return this.http
      .get<any>(environment.apiURL + 'get_user_details')
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  cancelAutoRenew(userId: string, purchaseId: string) {
    let obj = {};
    obj['auth_token'] = environment.authtoken;
    obj['ext_user_id'] = userId;
    obj['purchase_id'] = purchaseId;
    return this.http
      .post<any>(
        environment.apiURL + 'users/cancel_auto_renew.gzip',
        JSON.stringify(obj),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  playBackTimeUpdate(
    contentId: string,
    catalogId: string,
    play_back_time: string,
    dateTime: string
  ) {
    let obj = {};
    obj['user_id'] = window.localStorage.getItem('otv_user_login_id');
    obj['content_id'] = contentId;
    obj['catalog_id'] = catalogId;
    obj['playback_time'] = play_back_time;
    obj['date_time'] = dateTime;
    return this.http
      .post<any>(
        globals.playbackTimeEndpoint + 'nine_mobile/_doc',
        JSON.stringify(obj),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }
  // transaction init apiu
  // transactionInit(initdata: any, session: any) {
  //   return this.http
  //     .post<any>(
  //       environment.apiURL + 'users/' + session + '/transactions',
  //       JSON.stringify(initdata),
  //       this.options
  //     )
  //     .pipe(retry(1), catchError(this.commonService.handleError));
  // }
  transactionInit(initdata: any, session: any) {
    if (this.transactionInProgress) {
      return of(null);
    }
    this.transactionInProgress = true;
    return this.http
      .post<any>(
        environment.apiURL + 'users/' + session + '/transactions',
        JSON.stringify(initdata),
        this.options
      )
      .pipe(
        finalize(() => {
          this.transactionInProgress = false;
        }),
        retry(1),
        catchError(this.commonService.handleError)
      );
  }

  applyCouponCode(couponData: any, session_id) {
    //216.48.179.109:3003/v2/users/179260e4ebf08ef6b98e2eb656b53582/apply_coupon_code
    http: return this.http
      .post<any>(
        environment.apiURL + 'v2/users/' + session_id + '/apply_coupon_code',
        JSON.stringify(couponData),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }
  //  return curl -X POST "https://test.payu.in/_payment"-H "Content-Type: application/x-www-form-urlencoded" -d"key=JP***g&txnid=fM3O2HnkpJ8XEC&amount=100.00&firstname=PayU User&email=test@gmail.com&phone=9876543210&productinfo=iPhone&si=1&surl=https://apiplayground-response.herokuapp.com/&furl=https://apiplayground-response.herokuapp.com/&si_details={“billingAmount”: “100.00”,”billingCurrency”: “INR”,”billingCycle”: “MONTHLY”,”billingInterval”: 1,”paymentStartDate”: “2022-09-01″,”paymentEndDate”: “2022-12-01”}&hash=2ad878f64de47c7c1149ff554cd00ee44555a8512a1d2cff9690d6ea3c9d9de0bc44b0e77c61dd60a3c64ef970612a9b71761559aa202d2a278d29dc87b998c5"
  payupayment(paymentdata: any) {
    // this.options = { headers: new HttpHeaders ({ 'Content-Type': 'application/x-www-form-urlencoded' }) }
    return this.http
      .post<any>('https://test.payu.in/_payment', paymentdata, this.options)
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  gdpiStatus(data) {
    // return this.http.post<any>(environment.apiURL+'v2/users/verify', JSON.stringify(data), this.options)
    // /users/send_otp?auth_token=eKJTE4SSzAyKq3wdTCZ9
    return this.http
      .post<any>(
        environment.apiURL +
          'users/gdpr_status?auth_token=' +
          environment.authtoken,
        JSON.stringify(data),
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }

  getTime = (): any => {
    var x: any = new Date().toISOString();
    var remove_after = x.indexOf('.');
    var result = x.substring(0, remove_after);
    return result;
  };


  // uncomment these lines after we get analytics end points
  analytics(input) {
    // input = {
    //   ...input,
    //   event_time: this.getTime(),
    //   country: window.localStorage.getItem('region'),
    //   device_id: 'Guest',
    //   platform: 'web',
    //   city: 'NA',
    //   state:  'NA',
    //   ip: 'NA',
    //   postal_code: 'NA',
    //   u_id: JSON.parse(window.localStorage.getItem('user'))?.user_id,
    // };
    let data = {
      dataLayer: [
        {
          value: JSON.stringify(input),
        },
      ],
    };
    console.log(data, 'data from analytics');
    return this.http
      .post<any>(
        'https://staginganalytics.tarangplus.in/api/collect',
        data,
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  }




   // uncomment these lines after we get analytics end points
  sandbox_analytics(input) {
    // input = {
    //   ...input,
    //   app_version:'NA',
    //   device_brand:'NA',
    //   device_model:'NA',
    //   network_type: 'NA',
    //   os_version:'NA',
    //   country:window.localStorage.getItem('region'),
    //   device_id:'NA',
    //   platform: 'web',
    //   device_type: this.deviceType,
    //   screen_size: `${window.screen.width}*${window.screen.height}`,  
    //   city: window.localStorage.IPzip ? JSON.parse(window.localStorage.getItem('IPzip')).city_name.toLowerCase():"NA",
    //   state: window.localStorage.IPzip ?  JSON.parse(window.localStorage.getItem('IPzip'))?.state?.toLowerCase():"NA",
    //   ip_address: window.localStorage.IPzip ?  JSON.parse(window.localStorage.getItem('IPzip')).ip:"NA",
    //   // u_id:JSON.parse(window.localStorage.getItem('user')).user_id
    //   u_id: window.localStorage.user ? JSON.parse(window.localStorage.getItem('user')).user_id:"NA",
    //   subscription_status:window.localStorage.is_subscribed ? (JSON.parse(window.localStorage.is_subscribed) ? 'Active' : 'Inactive'): 'NA',
    //   user_state: window.localStorage.user_state ? window.localStorage.user_state : 'NA',
    // };
    alert('final data')
    alert(JSON.stringify(input))

    let data = {
      dataLayer: [
        {
          value: JSON.stringify(input),
        },
      ],
    };
    
    return this.http
      .post<any>(
        'https://staginganalytics.tarangplus.in/api/collect/sandbox',
        data,
        this.options
      )
      .pipe(retry(1), catchError(this.commonService.handleError));
  
  }



 
  
  userRegister(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiURL}users/register?auth_token=${environment.authtoken}`, 
      JSON.stringify(data), 
      this.options
    ).pipe(
      retry(1),
      catchError(this.commonService.handleError)
    );
  }

  async googleSignIn(region:any) {
    try {
      const userDetail = await this.afAuth.signInWithPopup(new firebase.auth.GoogleAuthProvider());

      if (userDetail.user) {
        const userData = {
          auth_token: `${environment.authtoken}`,
          user: {
            ext_account_email_id: userDetail.user.email,
            firstname: userDetail.user.displayName?.split(' ')[0] || '',
            provider: 'Google',
            uid: userDetail.user.uid,
            region: region,
          },
        };
            return this.http.post(`${environment.apiURL}users/external_auth/sign_in`, userData).toPromise();
      }
    } catch (error) {
      console.error('Google sign-in failed', error);
      throw error; 
    }
  }

  async facebookSignIn(region: any) {
  return new Promise((resolve, reject) => {

    if (typeof FB === 'undefined') {
      reject({ message: 'Facebook SDK not loaded' });
      return;
    }

    FB.login((response: any) => {

      if (!response.authResponse) {
        reject({ message: 'User cancelled Facebook login' });
        return;
      }

      FB.api(
        '/me',
        { fields: 'id,name,email' },
        (userInfo: any) => {

          const userData = {
            user: {
              uid: userInfo.id.toString(),
              firstname: userInfo.name,
              ext_account_email_id: userInfo.email,
              region: region,
              provider: 'facebook'
            },
            auth_token: environment.authtoken
          };

          this.http
            .post(
              `${environment.apiURL}users/external_auth/sign_in?auth_token=${environment.authtoken}`,
              userData
            )
            .subscribe({
              next: (res) => {
                resolve(res);   // ✅ THIS was missing
              },
              error: (err) => {
                reject(err);    // ✅ handle errors
              }
            });
        }
      );

    }, { scope: 'email,public_profile' });
  });
}

}  